<template>
  <header class="header" :style="{ transform: headerTransform, transformOrigin: 'top center' }">
    <div class="header-container">
      <div class="logo" @click="goHome">
        <!-- 默认 logo；透明态下切换为白色版 -->
        <img class="logo-default" src="@/assets/images/header/logo.png" alt="logo" />
        <img class="logo-white" src="../assets/images/product/logo-white.png" alt="logo" />
      </div>
      <nav class="nav" :class="{ 'transition-ready': indicatorReady }">
        <router-link to="/" class="nav-item" exact-active-class="active">{{ $t('nav.home') }}</router-link>
        <router-link to="/product" class="nav-item" active-class="active">{{ $t('nav.product') }}</router-link>
        <router-link to="/service" class="nav-item" active-class="active">{{ $t('nav.service') }}</router-link>
        <router-link to="/download" class="nav-item" active-class="active">{{ $t('nav.download') }}</router-link>
        <router-link to="/about" class="nav-item" active-class="active">{{ $t('nav.about') }}</router-link>
        <!-- 导航下划线指示器 -->
        <div class="nav-indicator" :style="{ left: indicatorLeft + 'px' }"></div>
      </nav>
      <div class="lang-dropdown" @click.stop>
        <div class="lang-switch" @click="toggleLang">
          <!-- 默认图标；透明态下切换为白色版 -->
          <img class="lang-icon lang-icon-default" src="../assets/images/header/Earth@2x.png" alt="语言" />
          <img class="lang-icon lang-icon-white" :src="earthWhite" alt="语言" />
          <span class="lang-text">{{ currentLangText }}</span>
        </div>
        <div class="lang-options" v-show="showLangOptions">
          <div class="lang-option" :class="{ active: $i18n.locale === 'zh' }" @click.stop="selectLang('zh')">{{ $t('lang.zh') }}</div>
          <div class="lang-option" :class="{ active: $i18n.locale === 'en' }" @click.stop="selectLang('en')">{{ $t('lang.en') }}</div>
        </div>
      </div>
      <!-- 移动端汉堡按钮 -->
      <div class="mobile-toggle" @click="mobileMenuOpen = !mobileMenuOpen">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <!-- 移动端下拉菜单 -->
    <div class="mobile-menu" v-show="mobileMenuOpen">
      <router-link to="/" class="mobile-menu-item" exact-active-class="active" @click.native="mobileMenuOpen = false">{{ $t('nav.home') }}</router-link>
      <router-link to="/product" class="mobile-menu-item" active-class="active" @click.native="mobileMenuOpen = false">{{ $t('nav.product') }}</router-link>
      <router-link to="/service" class="mobile-menu-item" active-class="active" @click.native="mobileMenuOpen = false">{{ $t('nav.service') }}</router-link>
      <router-link to="/download" class="mobile-menu-item" active-class="active" @click.native="mobileMenuOpen = false">{{ $t('nav.download') }}</router-link>
      <router-link to="/about" class="mobile-menu-item" active-class="active" @click.native="mobileMenuOpen = false">{{ $t('nav.about') }}</router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      showLangOptions: false,
      // 移动端菜单展开状态
      mobileMenuOpen: false,
      // 白色版地球图标（文件名含空格，需 require）
      earthWhite: require('@/assets/images/header/Earth (white).png'),
      // 导航栏缩放比例
      headerScale: 1,
      baseZoom: 1,
      // 导航下划线指示器位置
      indicatorLeft: 0,
      // 指示器是否就绪（首次定位跳过过渡）
      indicatorReady: false
    }
  },
  computed: {
    currentLangText() {
      return this.$i18n.locale === 'zh' ? this.$t('lang.zh') : this.$t('lang.en')
    },
    headerTransform() {
      return 'translateX(-50%) scale(' + this.headerScale + ')'
    }
  },
  watch: {
    // 路由切换后更新指示器
    $route() {
      this.$nextTick(() => this.updateIndicator())
    }
  },
  methods: {
    goHome() {
      if (this.$route.path === '/') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } else {
        this.$router.push('/')
      }
    },
    toggleLang() {
      this.showLangOptions = !this.showLangOptions
    },
    selectLang(lang) {
      this.showLangOptions = false
      if (lang === this.$i18n.locale) {
        return
      }
      // 记住语言偏好（localStorage 按域名独立存储）
      this.$i18n.locale = lang
      localStorage.setItem('locale', lang)
    },
    updateHeaderScale() {
      // 与画布相同的 cover 缩放
      const fit = Math.max(window.innerWidth / 1920, window.innerHeight / 1080)
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.headerScale = fit * zoom
    },
    // 移动指示器到当前激活项
    updateIndicator() {
      const navItems = this.$el.querySelectorAll('.nav-item')
      const path = this.$route.path
      let activeIndex = 0
      const routeMap = { '/': 0, '/product': 1, '/service': 2, '/download': 3, '/about': 4, '/join': 4, '/join/apply': 4 }
      if (routeMap[path] !== undefined) {
        activeIndex = routeMap[path]
      }
      if (navItems[activeIndex]) {
        const item = navItems[activeIndex]
        this.indicatorLeft = item.offsetLeft + (item.offsetWidth - 24) / 2
      }
      // 首次定位后再启用过渡
      if (!this.indicatorReady) {
        this.$nextTick(() => { this.indicatorReady = true })
      }
    }
  },
  mounted() {
    // 点击外部关闭下拉菜单
    this.closeLangOptions = () => {
      this.showLangOptions = false
    }
    document.addEventListener('click', this.closeLangOptions)
    this.baseZoom = window.devicePixelRatio || 1
    this.updateHeaderScale()
    window.addEventListener('resize', this.updateHeaderScale)
    this.$nextTick(() => this.updateIndicator())
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeLangOptions)
    window.removeEventListener('resize', this.updateHeaderScale)
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 50%;
  width: 1920px;
  height: 80px;
  background: #fff;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 底部分割线，透明态下隐藏 */
.header::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background: #E5E5E5;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.header.header-transparent::after {
  opacity: 0;
}

.header-container {
  width: 1400px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0 auto;
}

.nav {
  display: flex;
  margin-left: 330px;
  position: relative;
}

.lang-dropdown {
  margin-left: auto;
  margin-right: -80px;
  position: relative;
}

.logo {
  cursor: pointer;
}

.logo img {
  height: 48px;
}

/* 透明态 logo */
.logo .logo-white {
  display: none;
}

.header.header-transparent .logo .logo-default {
  display: none;
}

.header.header-transparent .logo .logo-white {
  display: block;
}

.nav-item {
  font-size: 16px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s;
  width: 160px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.nav-item:hover {
  color: #00ADBB;
}

.nav-item.active {
  color: #00ADBB;
  outline: none;
}

/* 导航下划线指示器 */
.nav-indicator {
  position: absolute;
  bottom: 4px;
  width: 24px;
  height: 3px;
  border-radius: 2px;
  background: #00ADBB;
  transition: background 0.3s ease;
}

/* 透明态下变白 */
.header.header-transparent .nav-indicator {
  background: #FFFFFF;
}

.nav.transition-ready .nav-indicator {
  transition: left 0.35s cubic-bezier(0.4, 0, 0.2, 1),
              width 0.35s cubic-bezier(0.4, 0, 0.2, 1),
              background 0.3s ease;
}

.lang-switch {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background: transparent;
  white-space: nowrap;
}

.lang-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* 透明态图标 */
.lang-icon-white {
  display: none;
}

.header.header-transparent .lang-icon-default {
  display: none;
}

.header.header-transparent .lang-icon-white {
  display: block;
}

.lang-text {
  font-size: 14px;
  color: #333;
}

.lang-options {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: #fff;
  border: 1px solid #00ADBB;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  z-index: 1001;
}

.lang-option {
  padding: 10px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
}

.lang-option:hover {
  background: #00ADBB;
  color: #fff;
}

.lang-option.active {
  background: #00ADBB;
  color: #fff;
}

/* 移动端菜单默认隐藏 */
.mobile-toggle {
  display: none;
}

.mobile-menu {
  display: none;
}

/* 移动端 */
@media (max-width: 1024px) {
  .header {
    left: 0;
    width: 100%;
    height: 60px;
    /* 覆盖行内 transform */
    transform: none !important;
  }

  .header-container {
    width: 100%;
    padding: 0 16px;
    justify-content: space-between;
  }

  .nav {
    display: none;
  }

  .logo img {
    height: 36px;
  }

  .lang-dropdown {
    margin-left: auto;
    margin-right: 0;
  }

  .mobile-toggle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-left: 12px;
    cursor: pointer;
  }

  .mobile-toggle span {
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
    background: #333;
    margin: 0 auto 5px;
  }

  .mobile-toggle span:last-child {
    margin-bottom: 0;
  }

  /* 透明态下变白 */
  .header.header-transparent .mobile-toggle span {
    background: #FFFFFF;
  }

  /* 下拉菜单 */
  .mobile-menu {
    display: block;
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    background: #FFFFFF;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
    z-index: 999;
  }

  .mobile-menu-item {
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 24px;
    font-size: 16px;
    color: #333;
    text-decoration: none;
    border-bottom: 1px solid #F0F0F0;
  }

  .mobile-menu-item.active {
    color: #00ADBB;
  }
}
</style>
